import * as Sentry from "@sentry/react";
import { SerializedUser, UserProfile } from "src/interfaces/user";

export const logError = (error: Error) => {
  Sentry.captureException(error);
};


export const setUserConfig = (user: SerializedUser | UserProfile ) => {
    Sentry.setUser({
        id: user.uid || 'Unknown', // User ID
        username: user.displayName || 'unknown', // Optional username
        email: user.email || 'unknown' // Optional email
      });
  };
